import { useEffect, useState } from "react"
import { PropTypes } from 'prop-types';


const Grade = ({ title, setGrade }) => {

    const [count, setCount] = useState(0)


    useEffect(()=>{
        setGrade(count)
    },[count])



    const handleAdd = () => {
        setCount(prev => prev + 1)

    }

    const handleSubtract = () => {
        if (count > 0) {

            setCount(prev => prev - 1)

        }
    }




    return (
        <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold">Grade {title}</h2>
            <div className="flex  gap-3 max-w-md">
                <button onClick={handleSubtract} className={` h-fit w-fit bg-white text-red-500 text-lg transition-all border border-gray-200 px-3 py-1 rounded-lg whitespace-pre-line`}>-</button>
                <span className="h-fit w-fit text-2xl font-semibold">{count}</span>
                <button onClick={handleAdd} className={`h-fit w-fit bg-white text-red-500 text-lg transition-all border border-gray-200 px-3 py-1 rounded-lg whitespace-pre-line`}>+</button>
            </div>
        </div>
    )
}
Grade.propTypes = {
    title: PropTypes.string,
    setGrade: PropTypes.func
}
export default Grade